module.exports = __webpack_public_path__ + "img/1-1-p2.58d04845.svg";